'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.default = createTypes;

var _utils = require('./utils');

function createTypes(actionKeys, NAMESPACE) {
  return actionKeys.reduce(function (acc, actionName) {
    var _extends2;

    return _extends({}, acc, (_extends2 = {}, _extends2[actionName] = NAMESPACE + '_' + (0, _utils.parseToUppercase)(actionName), _extends2));
  }, {});
}

;